import { Button, Card, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams, withRouter } from 'react-router-dom';
import PartnerApi from '../../functions/api/partner/PartnerApi';
import UserApi from '../../functions/api/user/UserApi';
import { Procedure } from '../../type/entity';
import CustomerDetailProc from './CustomerDetailProc';
import RentaHistory from './RentaHistory';

interface CustomerInfo {
  name: string;
  email: string;
  city: string;
  phone: string;
}

function CustomerDetail() {
  const [listProc, setListProc] = useState<Procedure[]>([]);
  const [userImage, setUserImage] = useState([]);
  const customer = useParams<any>();
  const customerId = customer.customerId;
  const history = useHistory();
  const [customerInfo, setCustomerInfo] = useState<CustomerInfo>({
    name: '',
    email: '',
    city: '',
    phone: '',
  });

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {}, [userImage]);

  function handReload() {
    getData();
  }

  async function getData() {
    const listProc = await PartnerApi.getProcedures();
    setListProc(listProc);
    const userImage = await UserApi.getImages(customerId);
    setUserImage(userImage);
    const customer = await UserApi.getUserById(customerId, false);
    setCustomerInfo({
      name: customer.data.user_acc_full_name,
      email: customer.data.user_acc_emai,
      city: '',
      phone: customer.data.user_acc_phon,
    });

    setListProc(listProc);
  }

  return (
    <>
      <Button onClick={() => history.go(-1)} className="mb-3">
        Quay lại
      </Button>
      <Row gutter={[16, 16]}>
        <Col span={16}>
          <Card title="Hồ sơ khách hàng">
            <Row className="mb-3">
              <Col span={4}></Col>
              <Col span={10}>Tài liệu</Col>
              <Col span={6}>Tình trạng</Col>
              <Col span={4}></Col>
            </Row>
            {listProc.map((item) => {
              return (
                <CustomerDetailProc
                  proc={item}
                  userImage={userImage}
                  onUploadSuccess={handReload}
                />
              );
            })}
          </Card>
        </Col>
        <Col span={8}>
          <Card title="Thông tin khách hàng">
            <Row>
              <Col span={8}>Tên:</Col> <Col span={16}>{customerInfo.name} </Col>
            </Row>
            <Row>
              <Col span={8}>SĐT:</Col>{' '}
              <Col span={16}>{customerInfo.phone} </Col>
            </Row>
            <Row>
              <Col span={8}>Email:</Col>{' '}
              <Col span={16}>{customerInfo.email} </Col>
            </Row>
            <Row>
              <Col span={8}>Thành phố:</Col>{' '}
              <Col span={16}>{customerInfo.city} </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <RentaHistory customerId={customerId} />
    </>
  );
}

export default withRouter(CustomerDetail);
